module.exports = __webpack_public_path__ + "static/media/Wespath_W.b71d5318.png";